<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M41.0039 39.766L76.1573 31.7613"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.7852 43.203L76.9385 35.1983"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.5488 46.554L77.7022 38.5494"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.4102 50.3418L51.8552 48.4199"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M40.7342 75.1582L31.6511 35.2655C31.1435 33.0339 32.5392 30.8097 34.7708 30.3022L77.4213 20.5884"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M44.5756 76.2031L35.4812 36.2693C35.1827 34.9632 36.0037 33.6608 37.3098 33.3622"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.0436 79.8117C73.335 77.8786 75.7532 74.9604 77.3019 71.0569C78.8506 67.1535 79.1566 63.1381 78.2162 59.0107L76.0144 49.3454L62.692 47.5392L51.4668 54.9394L53.6685 64.6047C54.609 68.732 56.6204 72.2175 59.7103 75.0648C62.7965 77.9122 66.2409 79.4945 70.0436 79.8117Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M60.0018 90.5294C60.4347 87.7119 60.7706 84.8533 60.5504 82.0097C60.4944 81.282 60.4012 80.5506 60.166 79.8602C60.0578 79.543 59.8526 79.1885 59.5167 79.1848C59.1435 79.1848 58.942 79.6214 58.8898 79.9908C58.7853 80.7036 58.8823 81.4313 59.0167 82.1403C59.1771 82.9949 59.3861 83.8383 59.6473 84.6667C60.1325 86.2117 60.8116 87.7343 61.9498 88.8874C62.17 89.1076 62.4574 89.3315 62.7634 89.2606C62.9276 89.2232 63.0582 89.1076 63.1701 88.9807C63.6254 88.4545 63.7672 87.7268 63.7971 87.029C63.8381 85.9467 63.5508 84.4578 63.1291 83.4576C62.9985 83.1516 62.8305 82.8344 62.532 82.6926C62.3193 83.0621 62.3939 83.5285 62.4984 83.9428C62.6253 84.4466 62.8716 85.3422 63.0582 85.8273C63.297 86.4505 63.5993 87.0775 64.0993 87.5215C64.2673 87.6745 64.4874 87.8089 64.7114 87.7604C64.939 87.7119 65.0883 87.4954 65.1816 87.2827C65.6107 86.2901 65.036 84.4727 64.7412 83.4315C65.0174 84.357 65.5846 85.9654 66.066 86.805C66.2451 86.805 66.3123 86.5699 66.3309 86.3945C66.3869 85.7676 66.3683 84.6891 66.3309 83.9017C66.6556 84.4018 66.7004 84.5287 67.0624 85.0287C67.3423 85.4131 67.6333 85.7825 67.9132 85.9878C68.1931 86.193 68.5887 86.2901 68.8909 86.1184"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M90.3993 74.8596L91.474 79.3974C92.0786 81.9462 90.5149 84.5025 87.9773 85.1294L85.1113 85.8384"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.1035 61.0482L66.6829 66.9855L82.8527 47.5653"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M40.0395 113.916C42.1181 113.86 47.9173 113.42 52.1865 109.087C59.0119 102.161 57.564 90.2419 51.9663 84.2823C49.9064 82.088 46.4321 79.2705 41.8047 81.3118C39.491 82.3343 37.8154 84.6853 37.4571 86.9505C36.3488 93.9327 42.7824 99.7878 49.6974 98.31L65.2701 94.9775L88.59 89.9434L89.5005 89.7643C94.3444 88.7007 97.3671 83.868 96.2065 79.0466L83.7648 26.783C83.0259 23.6857 79.9211 21.7675 76.8199 22.4952L71.2073 23.8125"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M70.9676 20.2076L63.1159 21.9952C62.6047 22.1108 62.0673 22.025 61.6195 21.7489L60.2536 20.9129C60.597 19.9352 60.6492 18.8381 60.332 17.7559C59.6006 15.2742 57.0704 13.7069 54.5216 14.1584C51.581 14.6809 49.7263 17.5581 50.4167 20.4203C50.6555 21.4167 51.1742 22.275 51.8683 22.9356L51.1593 24.0961C50.8757 24.5589 50.4204 24.8873 49.8905 25.0104L41.229 26.9845C39.602 27.354 38.5832 28.9736 38.9526 30.6044C39.3221 32.2314 40.9417 33.2502 42.5725 32.8808L72.311 26.1076C73.9381 25.7381 74.9568 24.1185 74.5874 22.4877C74.2179 20.8607 72.5984 19.8419 70.9676 20.2114V20.2076ZM55.0665 17.629C55.7419 17.4648 56.4174 17.8827 56.5816 18.5545C56.7458 19.2299 56.3278 19.9054 55.6561 20.0696C54.9806 20.2338 54.3052 19.8158 54.141 19.1441C53.9768 18.4686 54.3947 17.7932 55.0665 17.629Z"
            class="primary-fill" />
    </svg>
</template>
